import {useDispatch, useSelector} from 'react-redux';

import {useAccountSettingsState} from './api';
import {toggleWidgetIsOpen} from './slice';

import type {WidgetIsOpenPayloadType} from './slice';

export function useSwitch(switchName: string): boolean {
  return useAccountSettingsState().data?.switches[switchName] || false;
}

export function useWidgetIsOpenState({
  contentType,
  objectId,
  widgetName,
}: Partial<WidgetIsOpenPayloadType>) {
  const key = `${contentType} ${objectId} ${widgetName}`;
  // default true because why not?
  return useSelector((state) => state.settings.widgetIsOpen[key] ?? true);
}

export function useToggleWidgetIsOpen() {
  const dispatch = useDispatch();
  return (props: WidgetIsOpenPayloadType) =>
    dispatch(toggleWidgetIsOpen(props));
}
